import React from "react";

export const UserContext = React.createContext<{val: null|string, setter:(val: null|string)=>void}>({val: null, setter: ()=>{}});